import * as _ from 'lodash';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';
import { DbTable } from '@finley-technologies/finley-types';

import { BorrowingBaseCalcs } from 'packages/calcAgentQA/ui/BorrowingBaseCalcs';

type BorrowingBaseCalculationsDisplayProps = {
  borrowingBaseReportFromLoanTapeCalcs: DbTable.BorrowingBaseReportFromLoanTapeCalcs;
};
export const BorrowingBaseCalculationsDisplay = ({
  borrowingBaseReportFromLoanTapeCalcs,
}: BorrowingBaseCalculationsDisplayProps) => {
  const {
    basicBorrowingBaseReport,
    concentrationLimitCalculations,
    eligibilityCriteriaCalculations,
  } = borrowingBaseReportFromLoanTapeCalcs;

  const mappedBorrowingBaseCalcs = _.map(
    _.entries(basicBorrowingBaseReport),
    ([key, value]) => ({
      key,
      label: commonUtils.toSentenceCase(key),
      value: value as number,
    }),
  );

  const mappedConcentrationLimitCalcs = _.map(
    concentrationLimitCalculations,
    (concentrationLimitCalculation) => ({
      key: concentrationLimitCalculation.concentrationLimitKey,
      label: commonUtils.toSentenceCase(
        concentrationLimitCalculation.concentrationLimitKey,
      ),
      value: concentrationLimitCalculation.borrowingBaseReduction,
    }),
  );

  const mappedEligibilityCriteriaCalcs = _.map(
    eligibilityCriteriaCalculations,
    (eligibilityCriteriaCalculation) => ({
      key: eligibilityCriteriaCalculation.eligibilityCriteriaKey,
      label: commonUtils.toSentenceCase(
        eligibilityCriteriaCalculation.eligibilityCriteriaKey,
      ),
      value: eligibilityCriteriaCalculation.eligibilityReduction,
    }),
  );

  return (
    <BorrowingBaseCalcs
      borrowingBaseCalcOutputs={mappedBorrowingBaseCalcs}
      eligibilityCriteriaCalcOutputs={mappedEligibilityCriteriaCalcs}
      concentrationLimitCalcOutputs={mappedConcentrationLimitCalcs}
    />
  );
};
